import { invokeApi } from '../bl_libs/invokeApi';
import { use_e2ee } from '../utils/utils';
import { LOCAL_STORAGE_KEYS } from '../utils/constants';

const authHeadersPost = () => ({
    Authorization: `Bearer ${JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token))}`,
});

/** License pool + module metadata (POST /v1/analytics/licenses/info). */
export const analyticsLicensesInfoService = async (org_code) => {
    return invokeApi(
        {
            path: '/analytics/licenses/info',
            method: 'POST',
            headers: authHeadersPost(),
            postData: { org_code },
        },
        use_e2ee(),
    );
};

/** Bulk user/license upload via insider CSV route. */
export const analyticsPostUsersCsvService = async ({ org_code, org_type, data, options }) => {
    return invokeApi(
        {
            path: '/dq_insider/dqin/client/licenses/post_users_csv',
            method: 'POST',
            headers: authHeadersPost(),
            postData: { org_code, org_type, data, options },
        },
        use_e2ee(),
    );
};

/**
 * Bulk upload — ASYNC variant. Returns { job_id, total_rows } immediately;
 * the upload itself runs server-side and is tracked via
 * analyticsCsvUploadJobStatusService polling.
 */
export const analyticsPostUsersCsvAsyncService = async ({ org_code, org_type, data, options }) => {
    return invokeApi(
        {
            path: '/dq_insider/dqin/client/licenses/post_users_csv_async',
            method: 'POST',
            headers: authHeadersPost(),
            postData: { org_code, org_type, data, options },
        },
        use_e2ee(),
    );
};

/** Poll an async upload job: { status, processed_rows, total_rows, row_errors, result }. */
export const analyticsCsvUploadJobStatusService = async ({ org_code, job_id }) => {
    return invokeApi(
        {
            path: '/dq_insider/dqin/client/licenses/csv_upload_job_status',
            method: 'POST',
            headers: authHeadersPost(),
            postData: { org_code, job_id },
        },
        use_e2ee(),
    );
};

/** Export slice (POST /v1/dqin/client/licenses/get_users_csv). */
export const analyticsGetUsersCsvService = async ({ org_code, keys }) => {
    return invokeApi(
        {
            path: '/dq_insider/dqin/client/licenses/get_users_csv',
            method: 'POST',
            headers: authHeadersPost(),
            postData: { org_code, keys },
        },
        use_e2ee(),
    );
};
